
<template>
  <el-select :disabled="disabled" :multiple="multiple" :collapse-tags="collapse" :value="value.id" filterable remote
    :placeholder="queryplace" clearable @input="change" @click.native="handleSelected()" :remote-method="remoteMethod">
    <el-option v-for="item in dataList" :disabled="item.disabled" :key="item.id" :label="`${item.name}(${item.needIntegral}积分)`" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { queryAllMallProductList } from "../api/api";
export default {
  name: "ProductSelect",
  props: {
    value: {
      type: Object,
      default() {
        return {
          id: "",
          name: ""
        };
      },
    },
    integral: {
      type: Number,
      default() {
        return 0;
      }
    },    
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      },
    },
    collapse: {
      type: Boolean,
      default() {
        return false;
      },
    },
    queryplace: {
      type: String,
      default: function () {
        return "请选择可兑换的商品";
      }
    },
  },
  data() {
    return {
      allList: [],
      dataList: [],
      productId: "",
      keySearch: ""
    };
  },
  methods: {
    remoteMethod(value) {
      let _this = this;
      _this.keySearch = value;
      if(_this.allList==null || _this.allList.length==0){
        queryAllMallProductList().then((res) => {
          _this.allList = res.data.response;
          _this.dataList = _this.allList.filter(x=>x.name.indexOf(value)>=0);
          _this.dataList.forEach(x=>{
            x.disabled = (x.needIntegral>_this.integral);
          });
        });
      }else{
        _this.dataList = _this.allList.filter(x=>x.name.indexOf(value)>=0);
        _this.dataList.forEach(x=>{
            x.disabled = (x.needIntegral>_this.integral);
        });
      }
    },
    queryAllMallProductList() {
      let _this = this;
      queryAllMallProductList().then((res) => {
        _this.allList = res.data.response;
        _this.dataList = _this.allList;
        _this.dataList.forEach(x=>{
            x.disabled = (x.needIntegral>_this.integral);
        });
      });
    },
    change(val) {
      let selectedData = this.allList.find(x=>x.id==val);
      if(selectedData){
        this.$emit("input", selectedData);
      }
    },
    handleSelected() {
      // 主动触发点击事件
      this.keySearch = "";
      this.queryAllMallProductList();
    },
    check(val) {
      if (this.value != null) {
        var index = this.allList.findIndex(s => s.id == this.value);
        if (index < 0) {
          this.keySearch = val;
          this.remoteMethod(val);
        }
      }
    }
  },
  watch: {
    "value": function (val) {
      this.check(val);
    }
  },
  mounted() {
    if (this.value) {
      this.productId = this.value;
    }
    if (this.disabled) {
      this.disabled = this.disabled;
    }
    if (this.multiple) {
      this.multiple = this.multiple;
    }
    if (this.collapse) {
      this.collapse = this.collapse;
    }
    this.queryAllMallProductList();
  },
};
</script>